import { useState, useEffect } from 'react'
import api, { INeighborhoodImport } from '@api'

export default function useActiveImport() {
  const [loading, setLoading] = useState(true)
  const [activeImport, setActiveImport] = useState<INeighborhoodImport | null>(null)

  useEffect(() => {
    api.neighborhood.import.active().then((activeImport) => {
      setLoading(false)
      setActiveImport(activeImport || null)
    })
  }, [])

  return { loading, activeImport }
}
